export default {
   layout: {
        zh: '中文简体',
        en: 'English',
        kr: '한국어',
        tc:'中文繁体',
        th:'泰语ภาษาไทย',
        vn:'Việt Nam'
    },
  footer: { desc: '' },
  menu: {
    home: 'Home',
    node: 'Node',
    exchange: 'Exchange',
    staking: 'Staking',
    me: 'My'
  },
  home: {
    ecological: 'Ecological Node',
    more: 'View More',
    genesis: 'Diamond Node',
    gold: 'Gold Node',
    onlyLeft: 'Only Left',
    coin: 'Coin Ratio',
    subscription: 'Buy Node',
    application: 'Eco Application Scenarios',
    desc1: 'Mall Points Redemption & Goods Payment',
    desc2: 'Node Subscription, Staking Income & Governance Voting',
    desc3: 'Gold Asset Exchange (RWA Mapping)',
    desc4: 'Merchant Profit Sharing & Dividend Incentives',
    desc5: 'Platform Fee Settlement & Profit Sharing',
    community: 'DAO Community Governance & Voting',
    partners: 'Partners',
    contact: 'Contact Us',
    limited: 'Limited',
    mat: 'Seats',
    lock: 'Lock-up Release',
    sky: 'Days'
  },
  node: {
    ecology: 'Ecological Node',
    meNode: 'My Nodes',
    genesis: 'Diamond Node',
    onlyLeft: 'Only Left',
    coin: 'Coin Ratio',
    subscription: 'Buy Node',
    diamond: 'Diamond Node',
    bronze: 'Bronze Node',
    revenue: 'View Earnings',
    gold: 'Gold Node',
    silver: 'Silver Node',
    noNode: 'No Nodes yet, Subscribe Now',
    totalCollection: 'Total Claimed',
    toBeClaimed: 'To Be Claimed',
    claimed: 'Claim',
    totalRelease: 'Total Released',
    released: 'Released',
    toBeReleased: 'To Be Released',
    genesisReleased: 'Diamond Node Release',
    more: 'Pull Down to Load More',
    nodeSubscription: 'Node Subscription',
    receivedTo: 'Claim To',
    networkFee: 'Network Fee',
    confirmSubscription: 'Confirm Subscription',
    progress: 'Transaction in Progress',
    executionSuccessful: 'Execution Successful',
    at: 'On',
    view: 'View on',
    releaseRecord: 'Release Records',
    claimRecord: 'Claim Records',
    nonce: 'Nonce',
    claimIncome: 'Claim Earnings',
    quantityClaimed: 'Claimed Quantity',
    pickup: 'Available to Claim',
    all: 'All',
    confirmToReceive: 'Confirm Claim',
    node0: 'Diamond Node',
    node1: 'Platinum Node',
    node2: 'Gold Node',
    node3: 'Emerald Node',
    node4: 'Silver Node',
    node5: 'Bronze Node',

       release1:'KOL Incentives',
       release2:'Global Airdrop',
       release3:'Liquidity Pool',
       release4:'Founding Team',
       release5:'Ecosystem Fund',
       release6:'Institutions',
       release7:'Global Nodes',
       release8:'Mining Pool',
       release9:'Staking Pool',

       
       success:'successful',
       error:'failed',
       nocount:'This node is sold out'

  },
  exchange: {
    at: 'On',
    view: 'View on',
    more: 'More',
    indicator: 'Indicator',
    market: 'Market Price Exchange',
    payment: 'Payment',
    all: 'All',
    received: 'Received',
    slippage: 'Slippage',
    minimum: 'Minimum Received',
    cost: 'Network Fee',
    confirmExchange: 'Confirm Exchange',
    record: 'History',
    completed: 'Completed',
    error: 'Failed',
    downMore: 'Pull Down to Load More',
    price: 'Price',
    progress: 'Transaction in Progress',
    wallet: 'Initiating Wallet',
    refuse: 'Reject',
    nodeSubscription: 'Node Subscription',
    executionSuccessful: 'Execution Successful',
    nonce: 'Nonce',
    confirm: 'Confirm'
  },
  me: {
    assets: 'Total Assets',
    recharge: 'Recharge',
    transfer: 'Transfer Out',
    record: 'History'
  },
  recharge: {
    recharge: 'Recharge',
    title: 'This address only supports NEX-related assets',
    address: 'Receiving Address',
    copy: 'Copy',
    share: 'Share'
  },
  record: {
    record: 'Records',
    all: 'All',
    recharge: 'Recharge',
    transfer: 'Transfer Out',
    claimed: 'Claim'
  },
  transfer: {
    transfer: 'Transfer Out',
    address: 'Withdrawal Address',
    transferCoin: 'Transfer Token',
    pla: 'Enter Withdrawal Address',
    network: 'Transfer Network',
    mainNetwork: 'Select Mainnet',
    transferAmount: 'Transfer Amount',
    withdraw: 'Min Withdrawal 20',
    all: 'All',
    balance: 'Available Balance',
    tips: 'Verify address & network carefully, assets irretrievable once on chain',
    amountReceived: 'Amount Received',
    free: 'Network Fee'
  }
};